import React from "react";
export class CalendarIcon extends React.Component {
    shouldComponentUpdate() {
        return false;
    }
    render() {
        const { active, className } = this.props;
        const fill = active ? "#C20000" : "#373435";
        return (<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" className={className}>
				<path fill={fill} fillRule="nonzero" d="M2 5.5h8V4a1 1 0 0 0-1-1h-.5v1a.5.5 0 0 1-1 0V3h-3v1a.5.5 0 0 1-1 0V3H3a1 1 0 0 0-1 1v1.5zm0 1V10a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V6.5H2zM8.5 2H9a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h.5V1a.5.5 0 0 1 1 0v1h3V1a.5.5 0 0 1 1 0v1z"/>
			</svg>);
    }
}
